<script setup lang="ts">
import ListSlug from "@/components/lists/list-accessory-slug.vue";

defineProps<{
  accessoryId: string;
}>();
</script>

<template>
  <section class="tab-accessory">
    <div class="content">
      <list-slug :owner-id="accessoryId" :type="null" />
    </div>
  </section>
</template>

<style lang="scss" scoped>
.tab-accessory {
  display: flex;
  flex-direction: column;
  padding-block: 1rem;
  gap: 1rem;

  .content {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
}

@media screen and (max-width: 1024px) {
  .tab-accessory {
    .content {
      padding-inline: 0;
    }
  }
}
</style>
